import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Layout } from '../components/Layout';
export function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const podcastEpisodes = [{
    title: 'How To Live Authentically & Empower Yourself',
    guest: 'Chinaza Favour',
    videoId: 'pm8nxSA40aQ'
  }, {
    title: "Single Mom to Marketing Manager: Monica Inyang's Journey of Resilience and Success",
    guest: 'Monica Inyang',
    videoId: '9RlzHiLj6S0'
  }, {
    title: "From Struggles to Success: Elisha Mamman's Blueprint for Building a Meaningful Life",
    guest: 'Elisha Mamman',
    videoId: 'zeFiEpmDi_s'
  }, {
    title: 'From Selling Bread to Building Leading Brands',
    guest: 'Somto Anekwe',
    videoId: '1ZPwtQ1JyYk'
  }, {
    title: 'How Aproko Doctor is Saving Lives',
    guest: 'Aproko Doctor',
    videoId: 'Ex4HLtco4SA'
  }, {
    title: 'Mastering Financial Freedom',
    guest: 'Jennifer Awirigwe',
    videoId: 'vXYFq-MQsoE'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % podcastEpisodes.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % podcastEpisodes.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + podcastEpisodes.length) % podcastEpisodes.length);
  };
  return <Layout data-id="element-227">
      {/* Hero Section */}
      <section className="bg-white" data-id="element-228">
        <div className="max-w-7xl mx-auto px-6 py-20 md:py-32" data-id="element-229">
          <div className="max-w-4xl mx-auto text-center" data-id="element-230">
            <h1 className="text-6xl md:text-8xl font-black mb-6 leading-tight text-black" data-id="element-231">
              This Is Where It{' '}
              <span className="relative inline-block" data-id="element-232">
                <span className="text-black" data-id="element-233">SHIFT</span>
                <span className="text-voices-gold" data-id="element-234">S</span>
                <svg className="absolute -right-4 top-0 w-32 h-32" viewBox="0 0 100 100" style={{
                transform: 'rotate(-15deg)'
              }} data-id="element-235">
                  <line x1="10" y1="50" x2="90" y2="30" stroke="#C41E3A" strokeWidth="8" strokeLinecap="round" data-id="element-236" />
                  <polygon points="90,30 85,25 95,20" fill="#C41E3A" data-id="element-237" />
                </svg>
              </span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-700 leading-relaxed" data-id="element-238">
              Voices with Victoria Live — a faith-forward gathering for the
              searching, the starting, the scaling, the surrendered, and the
              stewarding.
            </p>
            <div className="mb-8 max-w-3xl mx-auto" data-id="element-239">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-240">
                Why You Should Be There
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-241">
                Because life doesn't shift by accident. It shifts when you lean
                into the right spaces — with the right people, guided by the
                right voices.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-242">
                You'll leave refreshed, stretched, supported, and equipped to
                design your best year yet. This is where faith meets clarity.
                This is where your story transforms. This is where it shifts.
              </p>
              <p className="text-xl font-bold text-black mb-2" data-id="element-243">
                Join the Movement
              </p>
              <p className="text-lg text-gray-700" data-id="element-244">
                Don't wait for change — step into it.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-245">
              <Link to="/event" className="bg-voices-red text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors text-center" data-id="element-246">
                Register Now
              </Link>
              <a href="https://getdp.co/5Lq" target="_blank" rel="noopener noreferrer" className="bg-voices-gold text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-orange-600 transition-colors text-center" data-id="element-247">
                Get Your DP
              </a>
              <Link to="/podcast" className="bg-voices-navy text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-800 transition-colors text-center flex items-center justify-center gap-2" data-id="element-248">
                <PlayIcon size={20} data-id="element-249" />
                Listen to the Podcast
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Why Voices */}
      <section className="py-16 bg-gray-50" data-id="element-250">
        <div className="max-w-7xl mx-auto px-6" data-id="element-251">
          <div className="max-w-3xl mx-auto text-center" data-id="element-252">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-253">
              Why Voices?
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-254">
              We exist to hold space for honest conversations that move lives
              forward. Through faith-centered dialogue, we equip young
              professionals and creatives with the clarity, courage, and
              community necessary to navigate life's transitions with purpose.
            </p>
          </div>
        </div>
      </section>
      {/* About Voices with Victoria */}
      <section className="py-16 bg-white" data-id="element-255">
        <div className="max-w-7xl mx-auto px-6" data-id="element-256">
          <div className="text-center mb-12" data-id="element-257">
            <h2 className="text-4xl font-bold text-black mb-4" data-id="element-258">
              About Voices with Victoria
            </h2>
            <p className="text-2xl font-bold text-voices-red" data-id="element-259">
              This Is Where It Shifts.
            </p>
          </div>
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-260">
            <p data-id="element-261">
              Voices with Victoria is more than a podcast or an event — it's a
              movement. A space where faith meets purpose, where clarity is born
              out of confusion, and where young people are equipped to navigate
              the shifts that shape their lives.
            </p>
            <p data-id="element-262">
              Founded by Victoria Ndu, Voices with Victoria began as a
              heart-to-heart podcast — a safe space for honest conversations
              about growth, faith, and impact. Today, it has evolved into a
              dynamic platform that connects thousands of young professionals,
              entrepreneurs, and changemakers across Africa and beyond through
              curated experiences, live events, and storytelling.
            </p>
            <div className="grid md:grid-cols-3 gap-8 my-12" data-id="element-263">
              <div className="bg-voices-cream p-6 rounded-xl" data-id="element-264">
                <h3 className="text-xl font-bold text-black mb-3" data-id="element-265">
                  Our Mission
                </h3>
                <p className="text-gray-700" data-id="element-266">
                  To create authentic spaces that help young people find
                  clarity, grow in confidence, and step boldly into their
                  calling — one honest conversation at a time.
                </p>
              </div>
              <div className="bg-voices-cream p-6 rounded-xl" data-id="element-267">
                <h3 className="text-xl font-bold text-black mb-3" data-id="element-268">
                  Our Vision
                </h3>
                <p className="text-gray-700" data-id="element-269">
                  To become a trusted voice and safe community for young
                  Africans navigating the transitions of life — from searching
                  to starting, scaling, surrendering, and stewarding.
                </p>
              </div>
              <div className="bg-voices-cream p-6 rounded-xl" data-id="element-270">
                <h3 className="text-xl font-bold text-black mb-3" data-id="element-271">
                  Our Approach
                </h3>
                <p className="text-gray-700" data-id="element-272">
                  We believe life doesn't shift by accident — it shifts through
                  faith, clarity, and community.
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-voices-cream to-white rounded-xl p-8 my-8" data-id="element-273">
              <h3 className="text-2xl font-bold text-black mb-6" data-id="element-274">What We Do</h3>
              <div className="space-y-4" data-id="element-275">
                <div data-id="element-276">
                  <p className="font-semibold text-black" data-id="element-277">🌍 The Podcast:</p>
                  <p className="text-gray-700" data-id="element-278">
                    Real, raw, and reflective conversations featuring thought
                    leaders, young professionals, and everyday voices shaping
                    the future.
                  </p>
                </div>
                <div data-id="element-279">
                  <p className="font-semibold text-black" data-id="element-280">
                    🎙️ Voices Live Experiences:
                  </p>
                  <p className="text-gray-700" data-id="element-281">
                    Immersive gatherings like #VoicesLive2026 that combine
                    storytelling, networking, worship, and growth — all designed
                    to help young people shift from where they are to where
                    they're meant to be.
                  </p>
                </div>
                <div data-id="element-282">
                  <p className="font-semibold text-black" data-id="element-283">
                    💡 Community & Conversations:
                  </p>
                  <p className="text-gray-700" data-id="element-284">
                    An evolving community of dreamers and doers, connected
                    through social learning, storytelling, and shared
                    experiences.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-voices-red text-white rounded-xl p-8 text-center" data-id="element-285">
              <h3 className="text-2xl font-bold mb-4" data-id="element-286">Our Promise</h3>
              <p className="text-lg" data-id="element-287">
                You'll leave every encounter with Voices with Victoria
                spiritually refreshed, mentally stretched, emotionally
                supported, and practically equipped. Because this isn't just
                another platform — it's a journey of becoming.
              </p>
            </div>
            <div className="text-center mt-8" data-id="element-288">
              <p className="text-xl font-bold text-black mb-4" data-id="element-289">
                Join the Movement
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-290">
                Be part of the shift. Subscribe to the podcast. Attend an event.
                Share your story. Because when your voice rises, the world
                shifts.
              </p>
              <p className="text-lg font-semibold text-voices-red" data-id="element-291">
                #VoicesWithVictoria | #ThisIsWhereItShifts
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Podcast Carousel */}
      <section className="py-16 bg-gray-50" data-id="element-292">
        <div className="max-w-7xl mx-auto px-6" data-id="element-293">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-8 text-center" data-id="element-294">
            Catch Up on our Podcast
          </h2>
          <div className="relative max-w-5xl mx-auto" data-id="element-295">
            <div className="overflow-hidden rounded-xl shadow-2xl" data-id="element-296">
              <div className="aspect-video bg-black" data-id="element-297">
                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${podcastEpisodes[currentSlide].videoId}`} title={podcastEpisodes[currentSlide].title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="w-full h-full" data-id="element-298"></iframe>
              </div>
            </div>
            <div className="mt-6 text-center" data-id="element-299">
              <h3 className="text-2xl font-bold text-black mb-2" data-id="element-300">
                {podcastEpisodes[currentSlide].title}
              </h3>
              <p className="text-lg text-voices-gold font-semibold mb-4" data-id="element-301">
                with {podcastEpisodes[currentSlide].guest}
              </p>
            </div>
            <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-voices-navy p-3 rounded-full shadow-lg transition-all" data-id="element-302">
              <ChevronLeftIcon size={24} data-id="element-303" />
            </button>
            <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-voices-navy p-3 rounded-full shadow-lg transition-all" data-id="element-304">
              <ChevronRightIcon size={24} data-id="element-305" />
            </button>
            <div className="flex justify-center gap-2 mt-6" data-id="element-306">
              {podcastEpisodes.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-voices-red w-8' : 'bg-gray-300'}`} data-id="element-307" />)}
            </div>
            <div className="text-center mt-8" data-id="element-308">
              <Link to="/podcast" className="inline-flex items-center gap-2 bg-voices-red text-white px-8 py-3 rounded-lg font-bold hover:bg-red-700 transition-colors" data-id="element-309">
                <PlayIcon size={20} data-id="element-310" />
                View All Episodes
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Blog Posts */}
      <section className="py-16 bg-white" data-id="element-311">
        <div className="max-w-7xl mx-auto px-6" data-id="element-312">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-8 text-center" data-id="element-313">
            Latest from the Blog
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-314">
            {[{
            title: 'The Power of Voice: How Conversations Shape the Future',
            excerpt: 'In every generation, there are movements that shift the world — not through weapons or wealth, but through words.',
            image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&h=400&fit=crop',
            slug: 'power-of-voice',
            date: 'January 2025'
          }, {
            title: 'Behind the Scenes: How Voices with Victoria Became a Platform for Changemakers',
            excerpt: 'Every great idea begins with a question. Discover the journey of how Voices with Victoria evolved from a simple idea into a movement.',
            image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop',
            slug: 'behind-the-scenes',
            date: 'January 2025'
          }].map((post, index) => <Link key={index} to={`/blog/${post.slug}`} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 border-voices-red group" data-id="element-315">
                <img src={post.image} alt={post.title} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-316" />
                <div className="p-6" data-id="element-317">
                  <div className="text-voices-gold font-semibold text-sm mb-2" data-id="element-318">
                    {post.date}
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3 group-hover:text-voices-red transition-colors" data-id="element-319">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-320">{post.excerpt}</p>
                  <span className="text-voices-red font-semibold group-hover:text-red-700" data-id="element-321">
                    Read More →
                  </span>
                </div>
              </Link>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-voices-red text-white" data-id="element-322">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-323">
          <h2 className="text-4xl font-bold mb-6" data-id="element-324">Ready to Shift?</h2>
          <p className="text-xl mb-8" data-id="element-325">
            Join us at Voices Live 2026 or subscribe to stay connected with our
            community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-326">
            <Link to="/event" className="bg-white text-voices-red px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-327">
              Register for Event
            </Link>
            <Link to="/podcast" className="bg-voices-gold text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-orange-600 transition-colors" data-id="element-328">
              Explore Podcast
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}